/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './image.scss';
import './modifier/circle-image.scss';
import './modifier/distribution-teaser.scss';
import './modifier/mood.scss';
import './modifier/mood-conversion.scss';
import './modifier/logo.scss';
import './modifier/force-ratio.scss';
import './modifier/elevator-pitch.scss';
import './modifier/centered.scss';
